import { getCookie } from '../getcookie.js';
import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

export const handleBookingStatus = async (roomId,bookingDate, slot) => {
  console.log(slot)
    const payload = {
        "date": bookingDate,
        "room_id": roomId,
        "from": slot["from"],
        "to": slot["to"]
      };
    
      const headers = {
        'Content-Type': 'application/json',
        "Accept": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Authorization": getCookie("mawalog")
      };
    
      try {
        const response = await axios.get(apiUrl + "get_booking_details/"+slot["id"],  { headers:headers });
        console.log("Response:", response.data);
        return response.data; // Returning the response data
      } catch (error) {
        console.error("Error fetching booking details:", error);
        return error.response.data;
      }
  };

  export const getRemainderList = async () => {
   
     
      
        const headers = {
          'Content-Type': 'application/json',
          "Accept": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Authorization": getCookie("mawalog")
        };
      
        try {
          const response = await axios.get(apiUrl + "get_reminders",  { headers:headers });
          console.log("Response:", response.data);
          return response.data; // Returning the response data
        } catch (error) {
          console.error("Error fetching booking details:", error);
          return error.response.data;
        }
    };

    export const getRemainderDefaultApi = async () => {
   
     
      
      const headers = {
        'Content-Type': 'application/json',
        "Accept": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Authorization": getCookie("mawalog")
      };
    
      try {
        const response = await axios.get(apiUrl + "default_reminders",  { headers:headers });
        console.log("Response:", response.data);
        return response.data; // Returning the response data
      } catch (error) {
        console.error("Error fetching booking details:", error);
        return error.response.data;
      }
  };